<template>
  <div class="agrotechnical_scheme_dialog">
    <el-dialog
      title="项目信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="close"
      v-if="dialogVisible"
    >
      <el-tabs v-model="activeName" :before-leave="handleClickTabs">
        <el-tab-pane label="文件信息" name="project">
          <div v-if="activeName == 'project'">
            <bigScreenTitleBorder :title="'基础信息'"></bigScreenTitleBorder>
            <el-col :span="12">
              <el-form
                :model="ruleForm"
                inline
                ref="ruleForm"
                :rules="rules"
                label-width="130px"
                :disabled="isDetail"
              >
                <el-form-item label="适用区域:" prop="qhdm">
                  <el-cascader
                    class="textInput"
                    size="small"
                    ref="areaSelect"
                    v-model="ruleForm.qhdm"
                    :collapse-tags="false"
                    :options="areaOptions"
                    :props="areaProps"
                    @change="liandong"
                    :show-all-levels="false"
                    placeholder="请选择适用区域"
                    v-if="showQhdm"
                  >
                  </el-cascader>
                  <div v-show="areaText" class="area_select_model" @click="areaModelClick" :class="{active:!isDetail}">
                    {{areaText}}
                  </div>
                </el-form-item>
                <el-form-item label="发布标题:" prop="titile">
                  <el-input
                    class="textInput"
                    v-model="ruleForm.titile"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="截止日期:" prop="endTime">
                  <el-date-picker
                    size="small"
                    v-model="ruleForm.endTime"
                    type="date"
                    :picker-options="pickerOptions"
                    placeholder="选择时间">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </el-col>
            <bigScreenTitleBorder :title="'整体说明'"></bigScreenTitleBorder>
            <div class="detail" id="detail" style="height:500px;">
              <text-editor ref="textEditor"></text-editor>
            </div>
            <el-upload
              class="upload-demo"
              :disabled="isDetail"
              :action="actionurl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :headers="importHeaders"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :on-success="handlehange"
              :file-list="fileArrList"
              :before-upload='beforeUpload'
              accept=".pdf">
              <el-button size="small" type="primary" :disabled="isDetail">上传附件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传pdf文件，最多上传10个文件</div>
            </el-upload>
            <div slot="footer" style="text-align: center" class="dialog-footer">
              <!-- <el-button size="small" type="primary" plain @click="close"
                >取消</el-button
              > -->
              <!-- <el-button size="small" v-show="isDetail" type="primary" @click="activeEdit">编辑</el-button> -->
              <el-button size="small" v-show="!isDetail" type="primary" @click="goNext">下一步</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="项目配置" name="config">
          <div v-if="activeName == 'config'">
            <div class="flex-wrap">
              <bigScreenTitleBorder :title="'项目申报设置'"></bigScreenTitleBorder>
              <el-button type="primary" size="small" class="btn" @click="addProject" :disabled="isDetail">新增项目</el-button>
            </div>
            <div class="project-wrap" v-for="(item, idx) in projectList">
              <div class="project-line">
                <div class="project-name">
                  <span class="label"><span style="color:red;" class="xrequired"> </span>项目{{ idx + 1 }}: </span>
                  <el-input
                    placeholder="请输入子项目名称"
                    v-model="item.name"
                    :disabled="isDetail"
                    style="width: calc(100% - 90px);"
                  >
                  </el-input>
                </div>
                <div class="project-name">
                  <span class="label">仅示范社申报: </span>
                  <el-checkbox v-model="item.checked" :disabled="isDetail"></el-checkbox>
                </div>
                <div class="project-name">
                  <el-button type="primary" size="small" @click="addClassification(idx)" :disabled="isDetail">增加分类项</el-button>
                  <el-button type="warning" size="small" :disabled="projectList.length == 1 || isDetail" @click="deleteProject(idx)">删除子项目</el-button>
                </div>
              </div>

              <div class="project-name" style="margin-top: 12px;">
                <span class="label">申报要求: </span>
                <el-input
                  type="textarea"
                  placeholder="请输入申报要求"
                  v-model="item.applyAsk"
                  :disabled="isDetail"
                  :rows="3"
                  style="width: calc(100% -110px);"
                >
                </el-input>
              </div>

              <div class="project-name-top" v-for="(projectItem, projectIdx) in item.projectConfigClassList" style="margin-top: 12px;">
                <span class="label"><span style="color:red;" class="xrequired"> </span>分类项{{ projectIdx + 1 }}: </span>
                <el-input
                  :disabled="isDetail"
                  placeholder="请输入分类项名称"
                  v-model="projectItem.className"
                >
                </el-input>
                <el-button type="primary" :disabled="isDetail" icon="el-icon-minus" circle size="small" @click="deleteProjectItem(idx, projectIdx)"></el-button>
              </div>
            </div>

            <div slot="footer" style="text-align: center" class="dialog-footer" v-show="!isDetail">
              <!-- <el-button size="small" type="primary" plain @click="close"
                >取消</el-button
              > -->
              <el-button size="small" type="primary" plain @click="goPrev">上一步</el-button>
              <el-button size="small" type="primary" @click="submit">保存</el-button>
            </div>
          </div>
        </el-tab-pane>

      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import textEditor from './textEditor.vue'
import API from "@/api/api_project/api_project";
import API_dic from "@/api/api_common";
import bigScreenTitleBorder from "@/components/headerTitle/bigScreenTitleBorder.vue"
export default {
  components:{
    bigScreenTitleBorder,
    textEditor,
  },
  data() {
    let that = this;
    return {
      showQhdm: false,
      activeName: 'project',
      dialogVisible: false,
      areaCode: Cookies.get('curAreaCode'),
      areaName: Cookies.get('curAreaName'),
      qhdm: Cookies.get('curAreaCode'),
      qhmc: Cookies.get('curAreaName'),
      userName: Cookies.get('username') == 'null' ? Cookies.get("accountName") : Cookies.get('username'),
      ruleForm: {
        titile: "",
        qhdm: "",
        qhmc: '',
        content: '',
        pulishTime: '',
        endTime: '',
      },
      rules:{
        titile: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择截止日期", trigger: ['change', 'blur'] },
        ],
        qhdm: [
          { required: true, message: "请选择适用区域", trigger: "change" },
        ],
      },
      actionurl: process.env.baseMachineryServer + "/file/upload", //图片信息
      importHeaders:  {
        Authorization: Cookies.get("token"),
        // Appid: '75de62ff979e40b7ad933e426cbaf639',
        Appid: '64c0dba9d3dc4fd7b02a2e8f427930b1',
      },
      isDetail: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      areaOptions: null,
      areaProps: {
        label: "qhmc",
        value: "qhdm",
        children: "children",
        checkStrictly: true,
      },
      // areaProps: {
      //   label: 'qhmc',
      //   value: 'qhdm',
      //   children: 'children',
      //   checkStrictly: true,
      //   lazy: true,
      //   lazyLoad (node, resolve) {
      //     console.log('node', node)
      //     let nodes;
      //     if (node.level === 0) {
      //       console.log(1)
      //       // console.log('qhdm', that.ruleForm.qhdm)
      //       let nodes = {
      //         qhdm: that.areaCode,
      //         qhmc: that.areaName,
      //         children: [],
      //         leaf: that.areaCode.length>=12
      //       }

      //       API_dic.getSysAreaSubarea({ qhdm: that.areaCode}).then((res) => {
      //         if (res.code == 0) {
      //           const list = res.data || []

      //           nodes.children  = list
      //           resolve([nodes])
      //         }
      //     })
      //   }
      //   else {
      //     console.log(2, node)
      //     if (node.value && node.value.length === 12) {
      //       console.log(3)
      //       nodes = [];
      //       resolve(nodes);
      //     } else {
      //       // if(node.children && node.children.length) {
      //       //   console.log('node.children', node.children)
      //       //   let children
      //       //   children =  node.children.filter(function(item, index, arr) {
      //       //     console.log('item', item)
      //       //     //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
      //       //     return arr.indexOf(item, 0) === index;
      //       //   });
      //       //   // children = [...new Set(node.children)]
      //       //   node.children = children
      //       //   node.children.filter((item) => item.value)
      //       //   resolve([node])
      //       //   console.log('children', children, node)
      //       // }
      //       // else {
      //         API_dic.getSysAreaSubarea({ qhdm: node.value }).then((res) => {
      //             console.log(res)
      //             if (res.code == 0) {
      //               const list = res.data || []

      //               nodes = list
      //               resolve(nodes)
      //             } else {
      //               that.GLOBAL.warning(res.message)
      //               nodes = []
      //               resolve(nodes)
      //             }
      //         }).catch((err) => {
      //           that.GLOBAL.warning(err)
      //           nodes = []
      //           resolve(nodes)
      //         })
      //       // }
      //     }

      // }
      //     // setTimeout(() => {
      //     //   let nodes;
      //     //   console.log(1, node)
      //     //   if(node.children && node.children.length > 0){
      //     //     nodes = []
      //     //     resolve(nodes);
      //     //   }else{
      //     //     API_dic.getSysAreaSubarea({qhdm: node.value}).then(res=>{
      //     //       nodes = res.data
      //     //       if(node.value.length==9){
      //     //         nodes.forEach(item=>{
      //     //           item.leaf = true
      //     //         })
      //     //       }
      //     //       resolve(nodes);
      //     //     })
      //     //   }
      //     //   // 通过调用resolve将子节点数据返回，通知组件数据加载完成
      //     //   // resolve(nodes);
      //     // }, 300);
      //   }
      // },
      dialogType: 'add',
      fileArrList:[],
      projectList: [{
        name: '',
        checked: false,
        projectConfigClassList: [],
        applyAsk: ''
      }],
      htmlVal: '',
      // 区划大于等于账号区划可编辑
      canEdit: false,
      areaText: ''
    };
  },
  created() {
    this.GLOBAL.eventBus.$on("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$on("firstLoadAreaOption", this.getNextXzqData); //
  },
  beforeDestroy() {
    this.GLOBAL.eventBus.$off("areaOptionsCompleted", this.getNextXzqData); //
    this.GLOBAL.eventBus.$off("firstLoadAreaOption", this.getNextXzqData); //
  },
  mounted(){
    // this.ruleForm.pulishName = this.userName;
    // 模拟 ajax 请求，异步渲染编辑器
    setTimeout(() => {
        this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
    }, 1500)
  },
  methods: {
    areaModelClick(){
      this.$refs.areaSelect.toggleDropDownVisible();
    },
    async getNextXzqData() {
      let regionOption = localStorage.getItem("areaOptions"); //获取乡级以上区域信息
      if (regionOption) {
        this.areaOptions = [JSON.parse(regionOption)];
      } else {
        this.areaOptions = null
      }
    },
    // 切换tab展示
    handleClickTabs(activeName, oldActiveName) {
      console.log(activeName, oldActiveName)
      if(activeName == 'project') {
        this.goPrev()
      } else {
        // return false不跳转 填写完文件再跳转
        return this.goNext('tab')
      }
    },
    // 点击上一步
    goPrev() {
      this.activeName = 'project'
      setTimeout(()=>{
        if(this.htmlVal) {
          this.$refs.textEditor.editor.txt.html(this.htmlVal)
        }
      },200)
    },
    // 点击下一步
    goNext(type) {
      let clickTab = false
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.activeName = 'config'
          clickTab = true

          if(this.$refs.textEditor.editor) {
            this.htmlVal = this.$refs.textEditor.editor.txt.html()
          }
        } else {
          // this.activeName = 'project'
          // this.$message({
          //   message: '请保证必填项都填写完毕再进行下一步',
          //   type: 'warning'
          // });
          clickTab = false
          return false;
        }
      })

      if(type == 'tab') {
        return clickTab
      }
    },

    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },

    // 删除子项目
    deleteProject(idx) {
      if(this.projectList.length == 1) {
        return false
      }

      this.projectList.splice(idx, 1)
    },

    // 删除分类项
    deleteProjectItem(idx, projectIdx) {
      this.projectList[idx].projectConfigClassList.splice(projectIdx, 1)
    },

    // 新增子项目
    addProject(){
      this.projectList.push({
        name: '',
        checked: false,
        projectConfigClassList: [],
        applyAsk: ''
      })
    },

    // 新增分类项
    addClassification(idx) {
      this.projectList[idx].projectConfigClassList.push({})
    },

    show(row,type) {
      this.isDetail = type =='detail';
      this.dialogType = type;
      this.activeName = 'project'

      this.getNextXzqData()

      if(this.$refs.textEditor) {
        this.$refs.textEditor.seteditor();
      }

      if(row){
        this.getRecordDetail(row)

        if (row.qhdm.length < this.areaCode.length) {
          this.canEdit = true
        } else {
          this.showQhdm = false
          this.canEdit = false
        }

        if(type == 'edit') {
          this.isDetail = false;
        }
      } else {
        this.showQhdm = true
        this.canEdit = false
        // this.ruleForm.qhdm = this.sub_qhdm(this.areaCode)
      }

      this.dialogVisible = true;
    },

    async getConfigDetail(row) {
      let params={
        pjInformationId:row.id
      }
      let { code, data, msg } = await API.getConfigList(params);

      if (code == 0 && data && data.list) {
        this.projectList = data.list.length && data.list.map((item) => {
          return {
            ...item,
            checked: item.isExample == 2
          }
        })
      }
    },

    sub_qhdm(qhdm){
      let returnQhdm
      const length = qhdm.length

      if(this.areaCode.length == 2) {
        switch (length) {
          case 2:
            returnQhdm = [qhdm.substring(0, 2)]
            break;

          case 4:
            returnQhdm = [qhdm.substring(0, 2), qhdm.substring(0, 4)]
            break;

          case 6:
            returnQhdm = [qhdm.substring(0, 2), qhdm.substring(0, 4), qhdm.substring(0, 6)]
            break;

          case 9:
            returnQhdm = [qhdm.substring(0, 2), qhdm.substring(0, 4), qhdm.substring(0, 6), qhdm.substring(0, 9)]
            break;

          case 12:
            returnQhdm = [qhdm.substring(0, 2), qhdm.substring(0, 4), qhdm.substring(0, 6), qhdm.substring(0, 9), qhdm]
            break;

          case length > 12:
            returnQhdm = qhdm.substring(0, 12)
            break;

          default:
            returnQhdm = []
            break;

        }
      } else if (this.areaCode.length == 4) {
        switch (length) {
          case 4:
            returnQhdm = [qhdm.substring(0, 4)]
            break;

          case 6:
            returnQhdm = [qhdm.substring(0, 4), qhdm.substring(0, 6)]
            break;

          case 9:
            returnQhdm = [qhdm.substring(0, 4), qhdm.substring(0, 6), qhdm.substring(0, 9)]
            break;

          case 12:
            returnQhdm = [qhdm.substring(0, 4), qhdm.substring(0, 6), qhdm.substring(0, 9), qhdm]
            break;

          case length > 12:
            returnQhdm = qhdm.substring(0, 12)
            break;

          default:
            returnQhdm = []
            break;
        }
      } else if (this.areaCode.length == 6) {
        switch (length) {

          case 6:
            returnQhdm = [qhdm.substring(0, 6)]
            break;

          case 9:
            returnQhdm = [qhdm.substring(0, 6), qhdm.substring(0, 9)]
            break;

          case 12:
            returnQhdm = [qhdm.substring(0, 6), qhdm.substring(0, 9), qhdm]
            break;

          case length > 12:
            returnQhdm = qhdm.substring(0, 12)
            break;

          default:
            returnQhdm = []
            break;
        }
      }

      console.log('re', returnQhdm)

      return returnQhdm
    },
    // 获取详情
    async getRecordDetail(row) {
      let params={
        id:row.id
      }
      let { code, data, msg } = await API.getInformationDetail(params);
      if (code == 0) {
        let article = data;
        this.ruleForm = article
        this.qhdm = data.qhdm;
        this.qhmc = data.qhmc;
        this.areaText = data.qhmc;

        if(data.qhdm) {
          article.qhdm = this.sub_qhdm(data.qhdm)
        }

        // this.showQhdm = false
        this.dialogVisible = true;
        this.fileArrList = this.ruleForm.informationFileList
        this.getConfigDetail(article)

        setTimeout(()=>{
          this.$refs.textEditor.editor.txt.html(article.content)

          if(this.dialogType == 'detail') {
            this.$refs.textEditor.editor.disable()
          }

          if (this.canEdit) {
            this.showQhdm = false
          } else {
            this.showQhdm = true
          }
        }, 200)
      }else{
        this.$message.error(msg);
      }
    },

    submit() {
      if(this.projectList && this.projectList.length) {
        let isValid = false
        this.projectList.forEach((proItem) => {
          if(proItem) {
            if(!proItem.name) {
              isValid = false
              this.$message.error('项目名称必填')
              return
            }

            if (proItem.projectConfigClassList && proItem.projectConfigClassList.length) {
              proItem.projectConfigClassList.forEach((projectItem) => {
                if (projectItem) {
                  if (!projectItem.className) {
                    isValid = false
                    this.$message.error('分类项名称必填')
                    return
                  } else {
                    isValid = true
                  }
                } else {
                  isValid = true
                }
              })
            } else {
              isValid = true
            }
          }
        })

        if (isValid) {
          let params
          params = {
            titile: this.ruleForm.titile,
            qhdm: this.qhdm,
            qhmc: this.qhmc,
            pulishTime: this.ruleForm.pulishTime,
            endTime: this.ruleForm.endTime,
            content: this.htmlVal,
            informationFileList: this.fileArrList
          }

          let requrestName = ''
          let configRequestname = ''
          let typeName =' '

          if(this.dialogType == 'add'){
            requrestName = 'informationSave'
            configRequestname =  'configSave'
            typeName = '新增'
            params = {...params, ...{ createBy: this.userName }}
          } else if(this.dialogType == 'edit') {
            requrestName = 'informationUpdate'
            configRequestname =  'configUpdate'
            typeName = '修改'
            params = {...params, ...{ updateBy: this.userName, id: this.ruleForm.id }}
          }

          this.$confirm("确定"+typeName+"该项目信息？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            API[requrestName](params).then(res=>{
              if(res.code==0){
                let configPamram
                let projectListAdd = this.projectList.map((item) => {
                  return {
                    name: item.name,
                    pjInformationId: res.data.id,
                    applyAsk: item.applyAsk,
                    isExample: item.checked ? 2 : 1,
                    createBy: this.userName,
                    projectConfigClassList: item.projectConfigClassList
                  }
                })
                let projectListEdit = this.projectList.map((item) => {
                  return {
                    id: item.id || '',
                    name: item.name,
                    pjInformationId: item.pjInformationId || res.data.id,
                    applyAsk: item.applyAsk,
                    isExample: item.checked ? 2 : 1,
                    updateBy: this.userName,
                    projectConfigClassList: item.projectConfigClassList
                  }
                })

                if(this.dialogType == 'add'){
                  configPamram = projectListAdd
                } else if(this.dialogType == 'edit') {
                  configPamram = projectListEdit
                }

                API[configRequestname](configPamram).then(({code, data, msg}) => {
                  if (code == 0) {
                    this.GLOBAL.success(msg)
                    this.GLOBAL.eventBus.$emit('refreshPublishList')
                    this.close()
                  } else {
                    this.GLOBAL.warning(msg)
                  }
                })
              } else{
                this.GLOBAL.warning(res.msg)
              }
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      }

    },

    resetProject() {
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
        this.$refs.textEditor.editor.destroy()
        this.$refs.textEditor.editor.null
      });
      this.qhdm = this.areaCode;
      this.htmlVal = ''
      this.qhmc = this.areaName;
      this.ruleForm = {
        titile: "",
        qhdm: "",
        qhmc: '',
        content: '',
        pulishTime: '',
        endTime: '',
      }
      this.fileArrList=[];
    },

    resetConfig() {
      this.projectList = [{
        name: '',
        checked: false,
        projectConfigClassList: [],
        applyAsk: ''
      }]
    },

    close() {
      this.resetProject()
      this.resetConfig()
      this.areaText = '';
      this.dialogVisible = false
    },

    liandong(obj){
      if(obj.length>0){
        this.qhdm = obj[obj.length - 1];
        this.qhmc = this.$refs.areaSelect.getCheckedNodes()[0].label;
        this.areaText = this.qhmc;
      }else{
        this.qhdm = this.areaCode;
        this.qhmc = this.areaName;
        this.areaText = '';
      }
    },

    handlehange(response, file, filelist){
      if (response.code == 0 || response.data) {
        setTimeout(() => {
          this.fileArrList = filelist.map((item) => {
            if (item.response) {
              return {
                name: item.name,
                url: item.response.data.filePath,
                fileUrl: item.response.data.filePath,
              }
            } else {
              if (item.fileUrl) {
                return {
                  name: item.name,
                  url: item.fileUrl,
                  fileUrl: item.fileUrl,
                }
              }
            }
          })
        }, 50)
      } else {
        this.$message.error("上传失败")
        return;
      }
    },
    handleRemove(file, fileList) {
      let index = this.fileArrList.findIndex((ele) => {
      return ele.uid === file.uid;
      });
      //当查找失败返回
      if (index === -1) {
        return console.log('删除失败');
      }
      this.fileArrList.splice(index, 1);
    },
    handlePreview(file) {
      window.open(file.fileUrl, '_blank')
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.warning("暂时只支持 pdf 格式", "error");
        return false;
      }
    },
  },
  computed: {
    windowWidth() {
      return document.body.clientWidth;
    },
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
};
</script>
<style lang="less">
.project-wrap {
  padding: 12px;
  border: 1px solid #f0f0f0;
  margin-top: 12px;

  & .label {
    display: inline-block;
    width: 110px;
    flex-shrink: 0;
    & .xrequired::before {
      content: '* ';
      color: red;
    }
  }
}

.project-line {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.project-name {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
}

.project-name-top {
  justify-content: flex-start;
}

.flex-wrap {
  display: flex;
  align-items: flex-end;

  & .btn {
    margin-bottom: 6px;
  }
}
.agrotechnical_scheme_dialog{
  .el-dialog{
    width: 960px;
    .el-dialog__body{
      padding-top: 10px;
      .el-form{
        margin-top: 16px;
        text-align: center;
      }
    }
    .area_select_model{
      position: absolute;
      background-color: #f5f7fa;
      border-radius: 4px;
      color: #c0c4cc;
      width: 260px;
      height: 30px;
      top: 6px;
      left: 4px;
      padding-left: 12px;
      box-sizing: border-box;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      &.active{
        background-color: #fff;
        color: #606266;
      }
    }
  }
  .demo-image__preview .el-image-viewer__close {
    color: #0464f3 !important;
  }
  .textInput,
  .el-date-editor,
  .el-input {
    width: 300px !important;
  }
  .eom_mag_hide{
    height: 148px;
    width: 148px;
    overflow: hidden;
    vertical-align: bottom;
  }
  .eom_mag_hide .el-upload--picture-card {
    display: none;
  }
  .eom_mag_hlist .el-upload--picture-card {
    display: none;
  }
  /*作业照片外层容器样式修改*/
  .img-form-item .el-form-item__content {
    width: 100%;
  }
  .dialog-footer {
    text-align: center;
  }
  .eom_mag_hide .el-upload--picture-card {
    display: none;
  }
  .icon-card{
    display: block;
    background-size: 148px 100px;
    background-repeat: no-repeat;
    background-position: center;
    width: 148px;
    height: 100px;
    margin-top: 24px;
  }
  .icon-card-front{
    // background-image: url("../../../../../static/img/card_front.png");
  }
  .icon-card-back{
    // background-image: /url("../../../../../static/img/card_back.png");
  }
  ::v-deep .el-upload-list__item {
    transition: none !important;
  }
  .evaluate {
    display: flex;
    margin-top: 20px;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;
    .stat {
      // width: 117px;
      height: 30px;
      line-height: 30px;
      margin-right: 20px;
      // background: #f1f3f5;
      border-radius: 16px;
      display: flex;
      align-items: center;
      font-size: 12px;
      div {
        width: 30%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i{
        font-size: 16px;
        color: #00955B;
      }
      // img {
      //   width: 16px;
      //   height: 16px;
      // }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/studio/publish/components/details.vue